import {Component, computed, effect, model, OnInit, signal, Signal} from '@angular/core';
import {MovieGenre} from '../../../../models/vision/movie';
import {RestApiService} from '../../../../services/api/rest-api.service';
import {ConfirmationService} from 'primeng/api';
import {DialogService} from 'primeng/dynamicdialog';
import {Card} from 'primeng/card';
import {ActionButtonComponent} from '../../../../components/form/action-buttons/action-button.component';
import {TableModule} from 'primeng/table';
import {InputText} from 'primeng/inputtext';
import {Button} from 'primeng/button';
import {FormGenreComponent} from '../form-genre/form-genre.component';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {InputComponent} from '../../../../components/form/input/input.component';
import {CheckboxComponent} from '../../../../components/form/checkbox/checkbox.component';
import {ToggleButton} from 'primeng/togglebutton';
import {FormsModule} from '@angular/forms';

@Component({
  selector: 'app-genres-list',
  imports: [
    Card,
    ActionButtonComponent,
    TableModule,
    Button,
    InputComponent,
    ToggleButton,
    FormsModule
  ],
  templateUrl: './genres-list.component.html',
  styleUrl: './genres-list.component.scss'
})
@UntilDestroy()
export class GenresListComponent implements OnInit {
  loading = false;
  originalGenres = signal<MovieGenre[]>([]); // Original genres loaded from the API
  genres = computed<MovieGenre[]>(() => {
    const filterValue = this.globalFilter().toLowerCase();
    const list = filterValue ? this.originalGenres()
      .filter(genre =>
        genre.name.toLowerCase().includes(filterValue) || genre.englishName.toLowerCase().includes(filterValue)
      ) : this.originalGenres();
    return list
      .filter(genre => (this.showGenres() || !genre.isSubGenre) && (this.showSubGenres() || genre.isSubGenre))
      .sort((a, b) => (a.isSubGenre ? 1 : 0) - (b.isSubGenre ? 1 : 0))
      .sort((a, b) => a.name.localeCompare(b.name));
  });

  globalFilter = model(''); // For global filtering in the table
  showGenres = model<boolean>(true);
  showSubGenres = model<boolean>(true);

  constructor(private api: RestApiService,
              private confirmationService: ConfirmationService,
              private dialogService: DialogService) {
    // effect(() => {
    //   const filterValue = this.globalFilter();
    // });
  }

  ngOnInit(): void {
    this._load(); // no await
  }

  private async _load() {
    try {
      this.loading = true;
      const response = await this.api.genres.getGenres();
      this.originalGenres.set(response.data);
    } finally {
      this.loading = false;
    }
  }

  editGenre(genre: MovieGenre) {
    const ref = FormGenreComponent.openDialog(this.dialogService, {
      genreId: genre.movieGenreId,
      type: genre.isSubGenre ? 'SubGenre' : 'Genre',
      name: genre.name
    })

    ref.onClose
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this._load(); // reload genres after edit
      });

  }

  addGenre(type: 'Genre' | 'SubGenre') {
    const ref = FormGenreComponent.openDialog(this.dialogService, {
      genreId: 0,
      type: type,
      name: ''
    });

    ref.onClose
      .pipe(untilDestroyed(this))
      .subscribe(() => {
        this._load(); // reload genres after adding a new one
      });
  }

  deleteGenre(genre: MovieGenre) {
    const typeGenre = genre.isSubGenre ? 'sottogenere' : 'genere';
    this.confirmationService.confirm({
      message: `Sei sicuro di voler eliminare il ${typeGenre} "${genre.name}"?<br>L'operazione non è reversibile.`,
      header: 'Conferma di eliminazione',
      icon: 'pi pi-exclamation-triangle',
      acceptIcon: 'pi pi-trash',
      rejectIcon: 'pi pi-times',
      acceptButtonStyleClass: 'p-button-danger',
      rejectButtonStyleClass: 'p-button-secondary p-button-text',
      acceptLabel: 'Elimina',
      rejectLabel: 'Annulla',
      accept: async () => {
        this.loading = true;
        try {
          await this.api.genres.deleteGenre(genre.movieGenreId);
          this._load(); // Reload genres after deletion
        } finally {
          this.loading = false;
        }
      }
    });
  }

  obj(item: MovieGenre) {
    return item;
  }
}
